import { graphqlSchema } from "app/graphqlSchema";
import { GraphQLObjectType, isObjectType } from "graphql";
import { Query, resolve } from "src/gqty";
import { getDefaultQueryFieldForType } from "./getDefaultQueryFieldForType";
import { findById } from "./findById";

export function getGraphQLRecordType(recordType: string): GraphQLObjectType {
  const type = graphqlSchema.getType(recordType);

  if (!type || !isObjectType(type)) {
    throw new Error(`Record type "${recordType}" was not found in the GraphQL schema.`);
  }

  return type;
}

export function getDefaultQueryNameForRecordType(recordType: string) {
  return getDefaultQueryFieldForType(getGraphQLRecordType(recordType)).name;
}

export function canOpenRecordType(recordType: string | null | undefined) {
  if (!recordType) return false;

  try {
    getDefaultQueryNameForRecordType(recordType);
    return true;
  } catch {
    return false;
  }
}

export async function hasResolvedRecordScreen(
  recordType: string | null | undefined,
) {
  if (!recordType || !canOpenRecordType(recordType)) return false;

  return resolve(({ query }) =>
    Boolean(query.resolvedRecordScreen({ recordType })?.id),
  );
}

export function getRecordByTypeAndId(
  query: Query,
  recordType: string,
  recordId: string,
) {
  const queryName = getDefaultQueryNameForRecordType(recordType) as keyof Query;
  const defaultQuery = query[queryName];

  if (typeof defaultQuery !== "function") {
    throw new Error(
      `Default query "${String(queryName)}" for "${recordType}" is not callable.`,
    );
  }

  return findById(defaultQuery as never, recordId);
}
